// import { setupLottieAnimations } from './module-lottie-intersection';
// setupLottieAnimations();
// lottieIntersection.js

// <div
//   id="lottie-animation-<ID>"
//   data-lottie-file
//   data-animation="{lottie.originalFile.publicUrl}"
//   data-autoplay="true"
//   data-loop="true"
//   data-onload="false"></div>

import lottie from 'lottie-web';

// Funktion zum Laden und Starten der Lottie-Animation
function loadLottieAnimation(container, animationData, shouldAutoplay, shouldLoop, height) {
  const animationParams = {
    container,
    renderer: 'svg',
    loop: shouldLoop,
    autoplay: shouldAutoplay,
    path: animationData,
  };

  // Lade und starte die Lottie-Animation
  const animation = lottie.loadAnimation(animationParams);

  // Funktion, um die Breite und Höhe der SVG-Elemente zu setzen, sobald die Animation geladen ist
  animation.addEventListener('DOMLoaded', () => {
    const svgElement = container.querySelector('svg');
    const width = animation.renderer.width;
    const animHeight = animation.renderer.height;
    const svgHeight = height || animHeight; // Verwende data-height oder Animation Standard-Höhe

    svgElement.removeAttribute('style');
    svgElement.removeAttribute('height');
    svgElement.removeAttribute('width');

    // setAttribute('height', ...) anstelle von style.height, weil es sonst nicht im Firefox geht
    svgElement.setAttribute('aspectRatio', `${width} / ${animHeight}`);
    svgElement.setAttribute('height', svgHeight);
  });
}


// Funktion, um die Lottie-Animation zu starten, wenn sie im Viewport ist
function playLottieAnimation(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const targetId = entry.target.id;
      const animationData = entry.target.dataset.animation;
      const shouldAutoplay = entry.target.dataset.autoplay === 'true'; // data-autoplay="true" oder nicht angegeben (Standard)
      const shouldLoop = entry.target.dataset.loop === 'true'; // data-loop="true" oder nicht angegeben (Standard)
      const height = entry.target.dataset.height; // Höhe aus data-height Attribut oder undefined, wenn nicht angegeben
      const animationContainer = document.getElementById(targetId);

      loadLottieAnimation(animationContainer, animationData, shouldAutoplay, shouldLoop, height);

      // Deaktiviere die Beobachtung des Ziels, sobald die Animation geladen und gestartet wurde, um mehrfache Animationen zu verhindern
      observer.unobserve(entry.target);
    }
  });
}

// Funktion, um Intersection Observer einzurichten und die Lottie-Animationen zu beobachten
export function setupLottieAnimations() {
  const options = {
    root: null, // null, um den Viewport als Root zu verwenden
    rootMargin: '0px',
    threshold: 0.1 // Der Wert, bei dem die Animation gestartet wird (0.1 bedeutet 10% sichtbar)
  };

  const observer = new IntersectionObserver(playLottieAnimation, options);

  // Beobachte alle Lottie-Animation-Container mit data-onload="false"
  const intersectionContainers = document.querySelectorAll('[data-lottie-file][data-onload="false"]');
  intersectionContainers.forEach(container => observer.observe(container));

  // Starte Lottie-Animationen mit data-onload="true" beim Laden der Seite
  const onLoadContainers = document.querySelectorAll('[data-lottie-file][data-onload="true"]');
  onLoadContainers.forEach(container => {
    const animationData = container.dataset.animation;
    const shouldLoop = container.dataset.loop === 'true'; // data-loop="true" oder nicht angegeben (Standard)
    const height = container.dataset.height; // Höhe aus data-height Attribut oder undefined, wenn nicht angegeben
    loadLottieAnimation(container, animationData, true, shouldLoop, height);
  });
}
